import styled, { css } from "styled-components";
import { ButtonProps } from "./Button.types";

// use isLoading to avoid DOM warning
interface Props extends ButtonProps {
    isLoading?: boolean;
  }
export const StyledButton = styled.button<Props>`
  user-select: none;
  position: ${({ position }) => position || "relative"};
  cursor: ${({ isDisabled, onClick }) =>
    isDisabled ? "not-allowed" : onClick ? "pointer" : "default"};
  pointer-events: ${({ isLoading }) => (isLoading ? "none" : "all")};
  box-sizing: border-box;
  white-space: ${({ whiteSpace }) => whiteSpace || "nowrap"};
  text-decoration: none !important;
  display: flex;
  flex-direction: row;
  justify-content: ${({ justifyContent }) => justifyContent || "center"};
  align-items: center;
  text-align: start;
  gap: ${({ theme }) => theme.space[4]};
  /* overflow: hidden; */
  transition: ${({ transition }) => transition};

  //ADD THEME-OPACITY
  opacity: ${({ isDisabled }) => (isDisabled ? 0.6 : 1)};

  //ADD THEME-SPACE?
  min-height: ${({ size, theme }) => theme.inputHeight(size)};

  //FOR SMALLICONBUTTON – is this really correct?
  width: ${({ theme, width, size }) => theme.buttonWidth(size, width)};

  min-width: ${({ size, theme }) => theme.inputHeight(size)};

  color: ${({ color }) => color || "inherit"};
  //ADD THEME-SPACE?

  padding: ${({ size, variant }) => {
    if (variant === "text") return "8px 0px";
    switch (size) {
      case "sm":
      case "small":
        return "8px 10px";
      case "md":
      case "medium":
        return "10px 12px";
      case "lg":
      case "large":
      default:
        return "13px 16px";
    }
  }};

  border-radius: ${({ size, theme }) => theme.borderRadius(size) || "16px"};

  font-size: ${({ size, fontSize }) =>
    fontSize || (size === "small" || size === "sm" ? "14px" : "16px")};
  font-weight: ${({ variant, weight }) =>
    weight ||
    ((variant === "primary" ||
      variant === "white" ||
      variant === undefined ||
      weight === "bold") &&
      "bolder")};

  ${({ variant, theme, isDisabled, color: textColor, onClick }) => {
    if (variant === "text")
      return css`
        &:hover {
          opacity: 0.6;
        }
      `;
    const type = (() => {
      switch (variant) {
        case "secondary":
          return "transparent";
        case "tertiary":
          return "invisible";
        case "white":
          return "white";
        case "whiteSecondary":
          return "white";
        case "alert":
          return "opaque";
        case "primary":
        case undefined:
        default:
          return "senf";
      }
    })();

    const color = (() => {
      if (textColor) return textColor;
      switch (variant) {
        case "alert":
          return "alert";
        default:
          return "grey";
      }
    })();
    const border = (() => {
      switch (variant) {
        case "white":
          return "light";
        case "tertiary":
          return false;
        default:
          return "dark";
      }
    })();
    return theme.layer({
      textColor,
      // interactive: false,
      interactive: !isDisabled && onClick,
      type,
      color,
      border,
      lightness: "dark",
    });
  }}

  box-shadow: ${({ shadow }) =>
    shadow === false && "0px 0px 0px 0px transparent"};

  //ADD THEME-BORDER
  ${({ borderStyle }) =>
    borderStyle ? `border: 2px ${borderStyle} rgba(0,0,0,0.2);` : null}//
`;